// extracted by mini-css-extract-plugin
module.exports = {"container":"EarnCoins_container__VMc8B","instructions":"EarnCoins_instructions__1p8bJ","instruction":"EarnCoins_instruction__JIuqI","head":"EarnCoins_head__3Sds3"};